import { Link } from "react-router-dom";
import { ArrowLeft, Shield, Lock, Eye, Database, Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-8 group">
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Zurück zur Startseite
          </Button>
        </Link>

        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-8">
            Datenschutzerklärung
          </h1>

          <div className="bg-card p-8 rounded-2xl shadow-soft border border-border mb-8">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center">
                <Shield className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h2 className="font-serif text-2xl font-bold text-foreground mb-1">
                  Ihre Privatsphäre ist uns wichtig
                </h2>
                <p className="text-muted-foreground">
                  Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen 
                  Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8 text-foreground/80">
            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Database className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  1. Verantwortlicher für die Datenverarbeitung
                </h2>
              </div>
              <p className="mb-4">
                Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
              </p>
              <div className="bg-muted/30 p-4 rounded-lg">
                <p>
                  Osman Baltaci<br />
                  Durlachstr. 11<br />
                  44339 Dortmund<br />
                  Deutschland<br />
                  E-Mail: osmanbaltaci@hotmail.com
                </p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Eye className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  2. Erhebung und Speicherung personenbezogener Daten
                </h2>
              </div>
              
              <h3 className="font-semibold text-foreground text-lg mb-2 mt-4">Beim Besuch der Website</h3>
              <p className="mb-4">
                Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser 
                automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden 
                temporär in einem sogenannten Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr 
                Zutun erfasst und bis zur automatisierten Löschung gespeichert:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
              </ul>

              <h3 className="font-semibold text-foreground text-lg mb-2 mt-6">Beim Kauf des E-Books</h3>
              <p className="mb-4">
                Der Verkauf erfolgt über die Plattform Payhip. Dabei werden folgende Daten erhoben:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>E-Mail-Adresse (für den Download-Link)</li>
                <li>Name (optional, für die Rechnung)</li>
                <li>Zahlungsinformationen (werden ausschließlich von Payhip verarbeitet)</li>
              </ul>
              <p className="mb-4">
                Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
              </p>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Cookie className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  3. Cookies
                </h2>
              </div>
              <p className="mb-4">
                Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert 
                werden. Einige der von uns verwendeten Cookies werden nach Ende der Browser-Sitzung, also nach 
                Schließen Ihres Browsers, wieder gelöscht (sog. Sitzungs-Cookies).
              </p>
              <p className="mb-4">
                Wir verwenden nur technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind. 
                Diese Cookies können nicht deaktiviert werden, da die Website sonst nicht ordnungsgemäß funktioniert.
              </p>
              <p className="mb-4">
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und 
                Cookies nur im Einzelfall erlauben. Weitere Informationen finden Sie in unserer{" "}
                <Link to="/cookies" className="text-primary hover:underline">Cookie-Richtlinie</Link>.
              </p>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Lock className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  4. Weitergabe von Daten an Dritte
                </h2>
              </div>
              
              <h3 className="font-semibold text-foreground text-lg mb-2">Payhip (Zahlungsabwicklung)</h3>
              <p className="mb-4">
                Wir nutzen Payhip als Zahlungsdienstleister für den Verkauf des E-Books. Payhip erhebt und 
                verarbeitet folgende Daten:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>E-Mail-Adresse</li>
                <li>Name (optional)</li>
                <li>Zahlungsinformationen</li>
                <li>IP-Adresse</li>
              </ul>
              <p className="mb-4">
                Weitere Informationen finden Sie in der{" "}
                <a 
                  href="https://payhip.com/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  Datenschutzerklärung von Payhip
                </a>.
              </p>

              <h3 className="font-semibold text-foreground text-lg mb-2 mt-6">Lovable (Website-Hosting)</h3>
              <p className="mb-4">
                Diese Website wird auf der Plattform Lovable gehostet. Dabei können Server-Logdaten verarbeitet werden. 
                Weitere Informationen finden Sie in der{" "}
                <a 
                  href="https://lovable.dev/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  Datenschutzerklärung von Lovable
                </a>.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                5. Ihre Rechte
              </h2>
              <p className="mb-4">Sie haben folgende Rechte:</p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>
                  <strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre gespeicherten personenbezogenen 
                  Daten verlangen (Art. 15 DSGVO).
                </li>
                <li>
                  <strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen 
                  (Art. 16 DSGVO).
                </li>
                <li>
                  <strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer Daten verlangen (Art. 17 DSGVO).
                </li>
                <li>
                  <strong>Einschränkung der Verarbeitung:</strong> Sie können die Einschränkung der Verarbeitung 
                  verlangen (Art. 18 DSGVO).
                </li>
                <li>
                  <strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung widersprechen (Art. 21 DSGVO).
                </li>
                <li>
                  <strong>Datenübertragbarkeit:</strong> Sie können die Übertragung Ihrer Daten verlangen 
                  (Art. 20 DSGVO).
                </li>
                <li>
                  <strong>Beschwerderecht:</strong> Sie können sich bei einer Aufsichtsbehörde beschweren 
                  (Art. 77 DSGVO).
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                6. Datensicherheit
              </h2>
              <p className="mb-4">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in 
                Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
              </p>
              <p className="mb-4">
                Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um 
                Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, 
                Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                7. Aktualität und Änderung dieser Datenschutzerklärung
              </h2>
              <p className="mb-4">
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand: November 2025.
              </p>
              <p>
                Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter 
                gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese 
                Datenschutzerklärung zu ändern.
              </p>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Datenschutz;
